import { useGlobal } from "../../../contexts/globalContext";
import { useJanusContext } from "../../../contexts/janus/JanusContext";

export const useSwitchScreen = () => {
  const { SET_MAIN_SCREEN_STREAM_LOADED } = useGlobal();
  const { StreamingPlugin } = useJanusContext();

  const switchScreen = (streamId, isFinalStream = false) => {
    if (isFinalStream) SET_MAIN_SCREEN_STREAM_LOADED(false);

    StreamingPlugin.current.send({
      message: { request: "switch", id: streamId },
      success: () => {
        console.log(`✅ [switchStream] 🠊 success (${streamId})`);
        if (isFinalStream) {
          setTimeout(() => {
            SET_MAIN_SCREEN_STREAM_LOADED(true);
          }, 1000);
        }
      },
    });
  };

  return {
    switchScreen,
  };
};
